import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import AccessToken from '@/components/User/AccessToken.vue'
import ChargeHistory from '@/components/Charge/History.vue'
import AutomaticRecharge from '../components/AutomaticRecharge/History.vue'
import Dashboard from '@/components/Dashboard.vue'
import extensionEdit from '@/components/Extension/Edit.vue'
import ExtensionList from '@/components/Extension/List.vue'
import IntegrationManager from '@/components/Integration/Manager.vue'
import Login from '@/components/User/Login.vue'
import OrganizationProfile from '@/components/Organization/Profile.vue'
import ChangePassword from '@/components/User/ChangePassword.vue'
import UserProfile from '@/components/User/Profile.vue'
import UsersNew from '@/components/Users/New.vue'
import UsersList from '@/components/Users/List.vue'
import ReportCalls from '@/components/Report/Calls.vue'
import Signup from '@/components/Organization/Signup.vue'
import FinancialData from '@/components/Organization/FinancialData.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'dashboard' },
      meta: { requiresAuth: true }
    }, {
      path: '/user/tokens',
      name: 'accessTokens',
      component: AccessToken,
      meta: { requiresAuth: true }
    }, {
      path: '/charge/history',
      name: 'chargeHistory',
      component: ChargeHistory,
      meta: { requiresAuth: true }
    }, {
      path: '/charge/automatic',
      name: 'automaticRecharge',
      component: AutomaticRecharge,
      meta: { requiresAuth: true }
    }, {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    }, {
      path: '/extension/:id/edit',
      name: 'extensionEdit',
      component: extensionEdit,
      meta: { requiresAuth: true }
    }, {
      path: '/extension/list',
      name: 'extensionList',
      component: ExtensionList,
      meta: { requiresAuth: true }
    }, {
      path: '/integrations/manager',
      name: 'integrationManager',
      component: IntegrationManager,
      meta: { requiresAuth: true }
    }, {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        showHeaderMenuAndFooter: false
      }
    }, {
      path: '/organization/profile',
      name: 'organizationProfile',
      component: OrganizationProfile,
      meta: { requiresAuth: true }
    }, {
      path: '/user/profile',
      name: 'userProfile',
      component: UserProfile,
      meta: { requiresAuth: true }
    }, {
      path: '/users/new',
      name: 'usersNew',
      component: UsersNew,
      meta: { requiresAuth: true }
    }, {
      path: '/users/list',
      name: 'usersList',
      component: UsersList,
      meta: { requiresAuth: true }
    }, {
      path: '/change-password',
      name: 'changePassword',
      component: ChangePassword,
      props: route => ({ access_token: route.query.access_token }),
      meta: {
        requiresAuth: false,
        showHeaderMenuAndFooter: false
      }
    }, {
      path: '/report/calls',
      name: 'reportCalls',
      component: ReportCalls,
      meta: { requiresAuth: true }
    }, {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta: {
        showHeaderMenuAndFooter: false
      }
    }, {
      path: '/financial-data',
      name: 'financialData',
      component: FinancialData,
      props: true,
      meta: { requiresAuth: true }
    }
  ]
})

store.dispatch('auth/syncRouter', router)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js